import { SxStyle } from '@aibees/shared/theme';
import { alpha } from '@mui/material';

export const closeIconSx: SxStyle = {
  cursor: 'pointer',
};

export const header: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => `${p.spacing(0.5)}`,
  justifyContent: 'space-between',
  flex: 1,
  width: '100%',
  px: 2,
};

export const title: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => `${p.spacing(0.5)}`,
  width: '100%',
};

export const backdrop: SxStyle = {
  background: (p) => `${alpha(p.palette.common.black, 0.2)}`,
  backdropFilter: 'blur(5px)',
};
